import React from 'react';
import { Row, Col, Card, Typography } from 'antd';
import { SmileOutlined, DashboardOutlined, RocketOutlined } from '@ant-design/icons';
import BreadcrumbCustom from '../widget/BreadcrumbCustom';
import './dashboard.less'; 

const { Title, Paragraph } = Typography;

class Dashboard extends React.Component {
    render() {
        return (
            <div className="dashboard-container">

                <BreadcrumbCustom />

                <div className="dashboard-welcome">
                    <Title level={2} className="animated-text">
                        欢迎使用 <span className="gradient-text">心睿咨询 CRM 系统</span>
                    </Title>
                    <Paragraph className="sub-text">
                        提升您的业务效率，让客户管理更加智能
                    </Paragraph>
                </div>

                <Row gutter={16} className="dashboard-stats">
                    <Col span={8}>
                        <Card hoverable className="stat-card">
                            <DashboardOutlined className="stat-icon" />
                            <Title level={3} className="stat-title">301</Title>
                            <Paragraph>今日访问量</Paragraph>
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card hoverable className="stat-card">
                            <RocketOutlined className="stat-icon" />
                            <Title level={3} className="stat-title">1,230</Title>
                            <Paragraph>本月新增客户</Paragraph>
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card hoverable className="stat-card">
                            <SmileOutlined className="stat-icon" />
                            <Title level={3} className="stat-title">98%</Title>
                            <Paragraph>客户满意度</Paragraph>
                        </Card>
                    </Col>
                </Row>

                <Card className="activity-card" hoverable>
                    <Title level={4}>最新动态</Title>
                    <ul className="activity-list">
                        <li>心睿咨询CRM系统上线啦！</li>
                        <li>点击菜单看看你的客户情况吧。</li>
                    </ul>
                </Card>
            </div>
        );
    }
}

export default Dashboard;
